<mat-progress-spinner *ngIf="isLoading | async" diameter='90' mode="indeterminate" style="position: absolute; top: 45%; margin-left: 47.5%; z-index: 5000;"></mat-progress-spinner>

<div appActivityEvents>
<router-outlet></router-outlet>
</div>